import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser, selectWithcookieData } from '../../../redux/WithcookieSlice';
import { useTranslation } from '../../../redux/TranslationHelper';
import Header from './Header';
import Footer from './Footer';
import Menu from './Menu';

const Layout = ({ children, ...props }) => {
  const [mobileMenuExpanded, setMobileMenuExpanded] = useState(false);
  const [expandedItems, setExpandedItems] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // props로 전달된 메뉴 데이터 확인 (프리뷰 모드에서 사용)
  const propsMainMenus = props.mainMenus || [];
  const propsGlobalMenus = props.globalMenus || [];
  const propsWithcookieData = props.withcookieData;
  
  // Redux에서 메뉴 데이터와 로그인 상태 가져오기
  const globalMenus = useSelector(state => state.withcookie?.globalMenus);
  const mainMenus = useSelector(state => state.withcookie?.mainMenus);
  const isUserLoggedIn = useSelector(state => state.withcookie?.isUserLoggedIn);
  const withcookieData = useSelector(selectWithcookieData);
  
  // 에디터 상태에서 직접 메뉴 데이터 가져오기
  const editorMenus = useSelector(state => state.editor?.menus);
  
  // 디버깅을 위한 데이터 출력
  
  
  // 사용할 메뉴 데이터 결정 - 우선순위: props > editorMenus > Redux 메뉴
  let menusToUse = [];
  
  // 1. props로 전달된 메뉴 데이터가 있으면 우선 사용 (프리뷰 모드)
  if (Array.isArray(propsMainMenus) && propsMainMenus.length > 0) {
   
    menusToUse = [...propsMainMenus];
    
    // 글로벌 메뉴가 있으면 추가
    if (Array.isArray(propsGlobalMenus) && propsGlobalMenus.length > 0) {
      menusToUse = [...menusToUse, ...propsGlobalMenus];
    }
  }
  // 2. 에디터 메뉴 데이터가 있는 경우 다음 우선 사용
  else if (Array.isArray(editorMenus) && editorMenus.length > 0) {
   
    menusToUse = [...editorMenus];
  }
  // 3. 그 다음으로 Redux의 withcookie 메뉴 데이터 사용
  else if (Array.isArray(mainMenus) && mainMenus.length > 0) {
   
    menusToUse = [...mainMenus];
    
    // 글로벌 메뉴가 있으면 추가
    if (Array.isArray(globalMenus)) {
      menusToUse = [...menusToUse, ...globalMenus];
    }
  }
  else {
   
  }

  useEffect(() => {
    // sticky footer를 위한 기본 스타일 적용
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.minHeight = '100vh';
    document.documentElement.style.height = '100%';
    
    // preloader 처리
    const preloader = document.querySelector('.preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.style.display = 'none';
      }, 1000);
    }
    
    // 새로운 모바일 메뉴 로직
    const mobileMenuTogglers = document.querySelectorAll('.side-menu__toggler');
    const rightMobileMenu = document.getElementById('right-mobile-menu');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const mobileMenuClose = document.getElementById('mobile-menu-close');
    
    // 모바일 메뉴 열기
    const openMobileMenu = () => {
      if (rightMobileMenu && mobileMenuOverlay) {
        rightMobileMenu.style.right = '0';
        mobileMenuOverlay.style.display = 'block';
        document.body.style.overflow = 'hidden'; // 스크롤 방지
      }
    };
    
    // 모바일 메뉴 닫기
    const closeMobileMenu = () => {
      if (rightMobileMenu && mobileMenuOverlay) {
        rightMobileMenu.style.right = '-320px';
        mobileMenuOverlay.style.display = 'none';
        document.body.style.overflow = ''; // 스크롤 복원
      }
    };
    
    // 이벤트 리스너 등록
    mobileMenuTogglers.forEach(toggler => {
      toggler.addEventListener('click', (e) => {
        e.preventDefault();
        openMobileMenu();
      });
    });
    
    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', (e) => {
        e.preventDefault();
        closeMobileMenu();
      });
    }
    
    if (mobileMenuOverlay) {
      mobileMenuOverlay.addEventListener('click', () => {
        closeMobileMenu();
      });
    }
    
    // 기존 사이드 메뉴 이벤트 리스너 처리 (충돌 방지)
    const sideMenuTogglers = document.querySelectorAll('.side-menu__toggler');
    const sideMenuCloseBtn = document.querySelector('.side-menu__close-btn');
    const sideMenuBlock = document.querySelector('.side-menu__block');
    
    // 이벤트 리스너 등록
    sideMenuTogglers.forEach(toggler => {
      toggler.addEventListener('click', (e) => {
        e.preventDefault();
        // 기존 메뉴 대신 새 메뉴 열기
        openMobileMenu();
      });
    });
    
    // 클린업 함수
    return () => {
      mobileMenuTogglers.forEach(toggler => {
        toggler.removeEventListener('click', openMobileMenu);
      });
      
      if (mobileMenuClose) {
        mobileMenuClose.removeEventListener('click', closeMobileMenu);
      }
      
      if (mobileMenuOverlay) {
        mobileMenuOverlay.removeEventListener('click', closeMobileMenu);
      }
      
      sideMenuTogglers.forEach(toggler => {
        toggler.removeEventListener('click', openMobileMenu);
      });
    };
  }, []);
  
  // 메뉴 액션 처리 함수
  const handleMenuClick = (e, menu) => {
    e.preventDefault();
    
    // 모바일 메뉴 닫기
    const rightMobileMenu = document.getElementById('right-mobile-menu');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    if (rightMobileMenu && mobileMenuOverlay) {
      rightMobileMenu.style.right = '-320px';
      mobileMenuOverlay.style.display = 'none';
      document.body.style.overflow = '';
    }
    
    // 메뉴 액션 처리
    if (menu.menuAction === 'logout') {
      dispatch(logoutUser()).then(() => {
        // 로그아웃 성공 후 홈 페이지로 이동
        navigate('/');
      });
      return;
    }
    
    // 외부 링크 처리
    if (menu.externalLink) {
      window.open(menu.externalLink, '_blank');
      return;
    }
    
    // 일반 내부 링크 처리
    navigate(process.env.PUBLIC_URL + menu.path);
  };
  
  // 모바일 메뉴용 서브메뉴 토글 함수
  const toggleSubmenu = (menuId, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    setExpandedItems(prevItems => {
      if (prevItems.includes(menuId)) {
        return prevItems.filter(id => id !== menuId);
      } else {
        return [...prevItems, menuId];
      }
    });
  };
  
  // 화살표 아이콘 렌더링 함수
  const renderArrowIcon = (isExpanded) => {
    return (
      <i 
        className={`fa ${isExpanded ? 'fa-angle-down' : 'fa-angle-right'}`} 
        style={{ 
          marginLeft: '5px', 
          fontSize: '16px',
          transition: 'transform 0.3s ease',
          transform: isExpanded ? 'rotate(0deg)' : 'rotate(0deg)'
        }}
      ></i>
    );
  };
  
  // 모바일 사이드 메뉴 렌더링 함수
  const renderMobileMenuItems = () => {
    // 메뉴 데이터가 없으면 기본 메뉴 반환
    if (!Array.isArray(menusToUse) || menusToUse.length === 0) {
     
      return (
        <>
          <li className="current">
            <Link to="/" onClick={() => handleNavigate('/')} style={{ padding: '12px 0', display: 'block', borderBottom: '1px solid #eee', color: '#000000', textDecoration: 'none' }}>홈</Link>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/greeting" onClick={() => handleNavigate('/greeting')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                협회 소개
              </Link>
              <button
                onClick={(e) => toggleSubmenu('about', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('about'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('about') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('about') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/greeting" onClick={() => handleNavigate('/greeting')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>인사말</Link></li>
              <li><Link to="/license" onClick={() => handleNavigate('/license')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>설립허가 및 고유번호증</Link></li>
              <li><Link to="/organization-chart" onClick={() => handleNavigate('/organization-chart')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>조직도</Link></li>
              <li><Link to="/vision" onClick={() => handleNavigate('/vision')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>협회비전</Link></li>
              <li><Link to="/ci" onClick={() => handleNavigate('/ci')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>협회 CI</Link></li>
            </ul>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/environmental-program" onClick={() => handleNavigate('/environmental-program')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                협회 사업
              </Link>
              <button
                onClick={(e) => toggleSubmenu('business', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('business'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('business') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('business') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/environmental-education" onClick={() => handleNavigate('/environmental-education')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>환경 교육 프로그램</Link></li>
              <li><Link to="/environmental-program" onClick={() => handleNavigate('/environmental-program')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>환경 체험 프로그램</Link></li>
              <li><Link to="/nature-restoration-project" onClick={() => handleNavigate('/nature-restoration-project')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>풀빛 세상 만들기</Link></li>
              <li><Link to="/csr-consulting" onClick={() => handleNavigate('/csr-consulting')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>기업 사회 공헌 컨설팅</Link></li>
            </ul>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/notice" onClick={() => handleNavigate('/notice')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                커뮤니티
              </Link>
              <button
                onClick={(e) => toggleSubmenu('community', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('community'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('community') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('community') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/notice" onClick={() => handleNavigate('/notice')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>공지사항</Link></li>
              <li><Link to="/free-board" onClick={() => handleNavigate('/free-board')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>자유게시판</Link></li>
              <li><Link to="/gallery" onClick={() => handleNavigate('/gallery')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>사진갤러리</Link></li>
            </ul>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/data-room" onClick={() => handleNavigate('/data-room')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                자료실
              </Link>
              <button
                onClick={(e) => toggleSubmenu('data', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('data'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('data') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('data') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/data-room" onClick={() => handleNavigate('/data-room')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>협회 자료</Link></li>
            </ul>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/donation" onClick={() => handleNavigate('/donation')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                후원 안내
              </Link>
              <button
                onClick={(e) => toggleSubmenu('donation', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('donation'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('donation') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('donation') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/donation" onClick={() => handleNavigate('/donation')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>후원신청</Link></li>
            </ul>
          </li>
          <li>
            <a href="#" onClick={(e) => toggleSubmenu('login', e)} style={{ padding: '12px 0', display: 'block', borderBottom: '1px solid #eee', color: '#000000', textDecoration: 'none' }}>
              로그인
              {renderArrowIcon(expandedItems.includes('login'))}
            </a>
            <ul className={`sub-menu ${expandedItems.includes('login') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('login') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/sign-up" onClick={() => handleNavigate('/sign-up')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>회원 가입</Link></li>
            </ul>
          </li>
        </>
      );
    }
    
   
    
    // 메뉴 항목 정렬 (order 기준)
    const sortedMenus = [...menusToUse].sort((a, b) => a.order - b.order);
    
    // parentId가 null인 메인 메뉴 항목만 필터링 (글로벌 메뉴 제외)
    const mainMenuItems = sortedMenus.filter(
      menu => menu.parentId === null && 
      menu.visible && 
      menu.type !== 'GLOBAL' && // 글로벌 메뉴는 표시하지 않음
      (
        (!menu.is_logged && !menu.is_not_logged) || // 로그인 관련 속성이 없는 경우 모두 표시
        (menu.is_logged && isUserLoggedIn) ||       // 로그인 필요 메뉴는 로그인 시만 표시
        (menu.is_not_logged && !isUserLoggedIn)     // 비로그인 메뉴는 로그아웃 시만 표시
      )
    );
    
   
    
    // 메인 메뉴 항목이 없으면 기본 메뉴 반환
    if (mainMenuItems.length === 0) {
     
      return (
        <>
          <li className="current">
            <Link to="/" onClick={() => handleNavigate('/')} style={{ padding: '12px 0', display: 'block', borderBottom: '1px solid #eee', color: '#000000', textDecoration: 'none' }}>홈</Link>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/greeting" onClick={() => handleNavigate('/greeting')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                협회 소개
              </Link>
              <button
                onClick={(e) => toggleSubmenu('about', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('about'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('about') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('about') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/greeting" onClick={() => handleNavigate('/greeting')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>인사말</Link></li>
              <li><Link to="/license" onClick={() => handleNavigate('/license')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>설립허가 및 고유번호증</Link></li>
              <li><Link to="/organization-chart" onClick={() => handleNavigate('/organization-chart')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>조직도</Link></li>
              <li><Link to="/vision" onClick={() => handleNavigate('/vision')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>협회비전</Link></li>
              <li><Link to="/ci" onClick={() => handleNavigate('/ci')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>협회 CI</Link></li>
            </ul>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/environmental-program" onClick={() => handleNavigate('/environmental-program')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                협회 사업
              </Link>
              <button
                onClick={(e) => toggleSubmenu('business', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('business'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('business') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('business') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/environmental-education" onClick={() => handleNavigate('/environmental-education')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>환경 교육 프로그램</Link></li>
              <li><Link to="/environmental-program" onClick={() => handleNavigate('/environmental-program')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>환경 체험 프로그램</Link></li>
              <li><Link to="/nature-restoration-project" onClick={() => handleNavigate('/nature-restoration-project')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>풀빛 세상 만들기</Link></li>
              <li><Link to="/csr-consulting" onClick={() => handleNavigate('/csr-consulting')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>기업 사회 공헌 컨설팅</Link></li>
            </ul>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/notice" onClick={() => handleNavigate('/notice')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                커뮤니티
              </Link>
              <button
                onClick={(e) => toggleSubmenu('community', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('community'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('community') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('community') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/notice" onClick={() => handleNavigate('/notice')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>공지사항</Link></li>
              <li><Link to="/free-board" onClick={() => handleNavigate('/free-board')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>자유게시판</Link></li>
              <li><Link to="/gallery" onClick={() => handleNavigate('/gallery')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>사진갤러리</Link></li>
            </ul>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/data-room" onClick={() => handleNavigate('/data-room')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                자료실
              </Link>
              <button
                onClick={(e) => toggleSubmenu('data', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('data'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('data') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('data') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/data-room" onClick={() => handleNavigate('/data-room')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>협회 자료</Link></li>
            </ul>
          </li>
          <li>
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
              <Link to="/donation" onClick={() => handleNavigate('/donation')} style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}>
                후원 안내
              </Link>
              <button
                onClick={(e) => toggleSubmenu('donation', e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 15px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#000000'
                }}
              >
                {renderArrowIcon(expandedItems.includes('donation'))}
              </button>
            </div>
            <ul className={`sub-menu ${expandedItems.includes('donation') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('donation') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/donation" onClick={() => handleNavigate('/donation')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>후원신청</Link></li>
            </ul>
          </li>
          <li>
            <a href="#" onClick={(e) => toggleSubmenu('login', e)} style={{ padding: '12px 0', display: 'block', borderBottom: '1px solid #eee', color: '#000000', textDecoration: 'none' }}>
              로그인
              {renderArrowIcon(expandedItems.includes('login'))}
            </a>
            <ul className={`sub-menu ${expandedItems.includes('login') ? 'active' : ''}`} style={{ 
              display: expandedItems.includes('login') ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              <li><Link to="/sign-up" onClick={() => handleNavigate('/sign-up')} style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}>회원 가입</Link></li>
            </ul>
          </li>
        </>
      );
    }
    
    return mainMenuItems.map(menu => {
      // 현재 메뉴의 하위 메뉴 항목 찾기
      const subMenus = sortedMenus.filter(
        item => item.parentId === menu.id && 
        item.visible && 
        item.type !== 'GLOBAL' &&
        (
          (!item.is_logged && !item.is_not_logged) || // 로그인 관련 속성이 없는 경우 모두 표시
          (item.is_logged && isUserLoggedIn) ||        // 로그인 필요 메뉴는 로그인 시만 표시
          (item.is_not_logged && !isUserLoggedIn)      // 비로그인 메뉴는 로그아웃 시만 표시
        )
      );
      const hasSubMenu = subMenus.length > 0;
      const isExpanded = expandedItems.includes(menu.id);
      
      return (
        <li key={menu.id} className={menu.path === window.location.pathname ? 'current' : ''}>
          {menu.externalLink || menu.menuAction ? (
            // 외부 링크나 특수 액션이 있는 메뉴
            <a 
              href="#" 
              onClick={(e) => handleMenuClick(e, menu)}
              style={{ padding: '12px 0', display: 'block', borderBottom: '1px solid #eee', color: '#000000', textDecoration: 'none' }}
            >
              {t(menu.name)}
            </a>
          ) : (
            // 일반 내부 링크 메뉴
            hasSubMenu ? (
              <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee' }}>
                <a 
                  href="#" 
                  onClick={(e) => handleMenuClick(e, menu)}
                  style={{ padding: '12px 0', display: 'block', flex: 1, color: '#000000', textDecoration: 'none' }}
                >
                  {t(menu.name || '메뉴')}
                </a>
                <button
                  onClick={(e) => toggleSubmenu(menu.id, e)}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '12px 15px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    color: '#000000',
                    transition: 'background-color 0.2s',
                    borderRadius: '4px'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  {renderArrowIcon(isExpanded)}
                </button>
              </div>
            ) : (
              <a 
                href="#" 
                onClick={(e) => handleMenuClick(e, menu)}
                style={{ padding: '12px 0', display: 'block', borderBottom: '1px solid #eee', color: '#000000', textDecoration: 'none' }}
              >
                {t(menu.name || '메뉴')}
              </a>
            )
          )}
          
          {hasSubMenu && (
            <ul className={`sub-menu ${isExpanded ? 'active' : ''}`} style={{ 
              display: isExpanded ? 'block' : 'none',
              paddingLeft: '15px',
              margin: '0 0 10px 0'
            }}>
              {subMenus.map(subMenu => (
                <li key={subMenu.id}>
                  {subMenu.externalLink || subMenu.menuAction ? (
                    // 외부 링크나 특수 액션이 있는 서브메뉴
                    <a 
                      href="#" 
                      onClick={(e) => handleMenuClick(e, subMenu)}
                      style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}
                    >
                      {t(subMenu.name)}
                    </a>
                  ) : (
                    // 일반 내부 링크 서브메뉴
                    <a 
                      href="#" 
                      onClick={(e) => handleMenuClick(e, subMenu)}
                      style={{ padding: '8px 0', display: 'block', fontSize: '14px', color: '#000000', textDecoration: 'none' }}
                    >
                      {t(subMenu.name || '서브메뉴')}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          )}
        </li>
      );
    });
  };
  
  // 내비게이션 핸들러 함수
  const handleNavigate = (path) => {
    // 모바일 메뉴 닫기
    const rightMobileMenu = document.getElementById('right-mobile-menu');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    if (rightMobileMenu && mobileMenuOverlay) {
      rightMobileMenu.style.right = '-320px';
      mobileMenuOverlay.style.display = 'none';
      document.body.style.overflow = '';
    }
    
    // 경로로 이동
    navigate(path);
  };

  return (
    <div className="page-wrapper" style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      overflow: 'visible'
    }}>
      <Menu />
      <Header 
        mainMenus={propsMainMenus.length > 0 ? propsMainMenus : mainMenus}
        globalMenus={propsGlobalMenus.length > 0 ? propsGlobalMenus : globalMenus}
        withcookieData={propsWithcookieData || withcookieData}
      />
      <div style={{ 
        flex: '1 0 auto',
        minHeight: '300px'
      }}>
        {children}
      </div>
      <Footer />
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <i className="fa fa-angle-up"></i>
      </a>
      {/* 오버레이 */}
      <div id="mobile-menu-overlay" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9990,
        display: 'none'
      }}></div>
      
      {/* 오른쪽 모바일 메뉴 (기존 사이드 메뉴 대체) */}
      <div id="right-mobile-menu" style={{
        position: 'fixed',
        top: 0,
        right: '-320px',
        width: '300px',
        height: '100%',
        backgroundColor: '#fff',
        zIndex: 9999,
        boxShadow: '-3px 0 10px rgba(0, 0, 0, 0.2)',
        transition: 'right 0.3s ease',
        overflowY: 'auto'
      }}>
        <div style={{ padding: '15px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            borderBottom: '1px solid #eee',
            paddingBottom: '15px',
            marginBottom: '15px'
          }}>
            <a href="#" id="mobile-menu-close" style={{
              fontSize: '18px',
              fontWeight: 'bold',
              color: '#333',
              textDecoration: 'none'
            }}>X</a>
          </div>
          <div className="mobile-menu-content">
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              {renderMobileMenuItems()}
            </ul>
          </div>
        </div>
      </div>
      
      {/* 기존 사이드 메뉴는 유지 (DOM에는 있지만 사용하지 않음) */}
      <div className="side-menu__block" style={{ display: 'none' }}>
        <div className="side-menu__block-inner">
          <div className="side-menu__top">
            <a href="#" className="side-menu__toggler side-menu__close-btn">X</a>
          </div>
          <nav className="mobile-nav__container">
            <ul className="main-menu__navigation">
              {/* 빈 리스트 */}
            </ul>
          </nav>
          <div className="side-menu__sep"></div>
        </div>
      </div>
    </div>
  );
};

export default Layout; 